import { LOAD_VALIDATIONS_ERROR, LOAD_VALIDATIONS_SUCCESS } from "./actionTypes";
import { setDataLoading, setDataError } from "./actionIdx";
import { createDB, getExistingData } from "./vtrIndexedDB";

export const loadValidations = () => (dispatch) => {
  dispatch(setDataLoading());
  createDB()
    .then(() => {
      getExistingData()
        .then((data) => {
          dispatch({
            type: LOAD_VALIDATIONS_SUCCESS,
            validationPayload: data,
          });
        })
        .catch((error) => {
          dispatch({
            type: LOAD_VALIDATIONS_ERROR,
            payload: error,
          });
        });
    })
    .catch((error) => {
      dispatch(setDataError({ idxDB: error }));
    });
};
